import { Select } from 'antd';
import { useContext } from 'react';
import { ThemeContext } from '../../shared/contexts/Theme.context';
const { Option } = Select;

import useLanguageSelector from './LanguageSelector.hook';

export default function LanguageSelector() {
  const { state, actions } = useLanguageSelector();
  const { state: theme } = useContext(ThemeContext);
  const selectStyle = { color: theme.titleColor };

  return state.languages && state.languages.length ? (
    <Select
      style={selectStyle}
      value={state.selectedLanguage}
      bordered={false}
      onChange={actions.handleChange}
    >
      {state.languages.map(({ label, lang }) => {
        return (
          <Option key={lang} value={lang}>
            {label}
          </Option>
        );
      })}
    </Select>
  ) : null;
}
